'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initProductContainers = exports.updateOptionGroupValue = exports.updateProductQuantity = exports.updatePrice = exports.updateInventory = exports.updateVariant = exports.getProductContainerData = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getVariant = function getVariant(id) {
  var state = _state2.default.get(id);
  var _state$_data = state._data,
      options = _state$_data.options,
      variants = _state$_data.variants;

  var selectedOptions = options.map(function (option) {
    return option.name;
  }).map(function (name) {
    return state[name];
  });
  var variant = variants.find(function (variant) {
    return selectedOptions.every(function (selectedOption) {
      return variant.variant.options.includes(selectedOption);
    });
  });
  return variant;
};

var getInitialOptionValues = function getInitialOptionValues(options) {
  return options.reduce(function (optionValues, option) {
    return Object.assign({}, optionValues, (0, _defineProperty3.default)({}, option.name, option.initialValue));
  }, {});
};

var getInitialVariantData = function getInitialVariantData(variants) {
  var _variants$find = variants.find(function (variant) {
    return variant.isInitialVariant;
  }),
      _variants$find$varian = _variants$find.variant,
      variantId = _variants$find$varian.id,
      price = _variants$find$varian.price,
      compare_at_price = _variants$find$varian.compare_at_price,
      inventory = _variants$find.inventory;

  return { variantId: variantId, inventory: inventory, price: price, compare_at_price: compare_at_price };
};

var getProductContainerData = exports.getProductContainerData = function getProductContainerData(productContainer) {
  var id = productContainer.dataset.containerId;

  var _JSON$parse = JSON.parse($(productContainer).find(_Dom2.default.imageData).text()),
      images = _JSON$parse.data;

  var _JSON$parse2 = JSON.parse($(productContainer).find(_Dom2.default.optionData).text()),
      options = _JSON$parse2.data;

  var _JSON$parse3 = JSON.parse($(productContainer).find(_Dom2.default.variantData).text()),
      variants = _JSON$parse3.data;

  var _JSON$parse4 = JSON.parse($(productContainer).find(_Dom2.default.productData).text()),
      product = _JSON$parse4.data;

  var initialOptionValues = getInitialOptionValues(options);
  var initialVariantData = getInitialVariantData(variants);
  var quantity = parseInt($(productContainer).find(_Dom2.default.quantityValue).val(), 10) || null;
  var sliders = _Dom2.default.getContainer('slider', false, productContainer);
  return Object.assign({
    _data: { images: images, options: options, variants: variants, product: product },
    id: id,
    change: 'product',
    container: 'product'
  }, initialOptionValues, initialVariantData, {
    quantity: quantity,
    sliders: sliders
  });
};

var getAllProductContainerData = function getAllProductContainerData() {
  return $(_Dom2.default.productContainer).get().map(getProductContainerData);
};

var updateVariant = exports.updateVariant = function updateVariant(data) {
  var _getVariant = getVariant(data.id),
      variantId = _getVariant.variant.id;

  var change = 'variant';
  var container = 'product';

  _state2.default.set(Object.assign({}, data, { variantId: variantId, change: change, container: container }));
  PubSub.publish(_Constants2.default.updateInventory, data);
  PubSub.publish(_Constants2.default.updatePrice, data);
  (0, _Helpers.setSearchParm)('variant', variantId);
};

var updateInventory = exports.updateInventory = function updateInventory(data) {
  var _getVariant2 = getVariant(data.id),
      inventory = _getVariant2.inventory;

  var change = 'inventory';
  var container = 'product';

  _state2.default.set(Object.assign({}, data, { inventory: inventory, change: change, container: container }));
};

var updatePrice = exports.updatePrice = function updatePrice(data) {
  var _getVariant3 = getVariant(data.id),
      _getVariant3$variant = _getVariant3.variant,
      price = _getVariant3$variant.price,
      compare_at_price = _getVariant3$variant.compare_at_price;

  var change = 'price';
  var container = 'product';

  _state2.default.set(Object.assign({}, data, { price: price, compare_at_price: compare_at_price, change: change, container: container }));
};

var updateProductQuantity = exports.updateProductQuantity = function updateProductQuantity(data) {
  var change = 'quantity';
  var container = 'product';

  _state2.default.set(Object.assign({}, data, { change: change, container: container }));
};

var updateOptionGroupValue = exports.updateOptionGroupValue = function updateOptionGroupValue(data) {
  var id = data.id,
      name = data.name,
      value = data.value;

  var change = name;
  var container = 'product';

  _state2.default.set((0, _defineProperty3.default)({ id: id, change: change, container: container }, name, value));
  PubSub.publish(_Constants2.default.updateVariant, data);
};

var initProductContainers = exports.initProductContainers = function initProductContainers(data) {
  return getAllProductContainerData().map(function (item) {
    return _state2.default.set(item);
  });
};